<template>
  <path
    d="M21 3.00018H3C1.9 3.00018 1 3.90018 1 5.00018V19.0002C1 20.1002 1.9 21.0002 3 21.0002H21C22.1 21.0002 23 20.1002 23 19.0002V5.00018C23 3.90018 22.1 3.00018 21 3.00018ZM11 11.0002H4C3.45 11.0002 3 10.5502 3 10.0002C3 9.45018 3.45 9.00018 4 9.00018H11C11.55 9.00018 12 9.45018 12 10.0002C12 10.5502 11.55 11.0002 11 11.0002ZM11 7.00018H4C3.45 7.00018 3 6.55018 3 6.00018C3 5.45018 3.45 5.00018 4 5.00018H11C11.55 5.00018 12 5.45018 12 6.00018C12 6.55018 11.55 7.00018 11 7.00018Z"
  />
</template>
